import s from "./InvestmentTab.module.scss"
import cn from "classnames"
interface InvestmentTabProps {
    moneyAmount: number
    currency: string
    setInputText: React.Dispatch<React.SetStateAction<string>>
}

export default function InvestmentTab({ moneyAmount, currency, setInputText } : InvestmentTabProps) {

    const nextStepRedirecthandler = () => {
        setInputText(moneyAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " "))
    }

    return (
        <li tabIndex={0} className={cn(s["investment-tab"], "label-100")}>
            <button onClick={() => nextStepRedirecthandler()} className={cn(s["investment-tab__btn"])}>
                <span>{moneyAmount.toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</span>
                <span>{currency}</span>
            </button>
        </li>
    )
}
